import React from 'react';
import { useQuery } from '@apollo/client';

import { getReportsList } from '@/api';
import MenuLink from './MenuLink';
import { getReportLink } from './private-layout.helpers';
import { useAvailabilityPageAccess } from '@/hooks/useAvailabilityAccess';
import { useMenusPageAccess } from '@/hooks/useMenusPageAccess';
import { usePermissions } from '@/permissions';
import { Page, ROUTES } from '@/constants';

type PrivateLayoutNavbarProps = {
  toggle: () => void;
};

const PrivateLayoutNavbar: React.FC<PrivateLayoutNavbarProps> = ({ toggle }) => {
  const { data } = useQuery(getReportsList);
  const reports = data?.getReportsConfigurations?.reportsConfigurations ?? [];
  const { canAccess } = usePermissions();
  const { hasAccess: hasAvailabilityAccess } = useAvailabilityPageAccess();
  const { hasAccess: hasMenusAccess } = useMenusPageAccess();

  return (
    <>
      <MenuLink
        to={ROUTES[Page.Dashboard]}
        icon="IconLayoutDashboardFilled"
        title="Dashboard"
        onClick={toggle}
      />
      {canAccess(Page.Calendar) && (
        <MenuLink
          to={ROUTES[Page.Calendar]}
          icon="IconCalendar"
          title="Calendar"
          onClick={toggle}
        />
      )}
      {hasAvailabilityAccess && (
        <MenuLink
          to={ROUTES[Page.Availability]}
          icon="IconCalendarTime"
          title="Availability"
          onClick={toggle}
        />
      )}
      {hasMenusAccess && (
        <MenuLink to={ROUTES[Page.Menus]} icon="IconToolsKitchen2" title="Menus" onClick={toggle} />
      )}
      {canAccess(Page.Reports) &&
        reports.map((item) => (
          <MenuLink
            key={item.menuTitle}
            to={getReportLink(item)}
            icon={item.iconName}
            title={item.menuTitle}
            onClick={toggle}
          />
        ))}
    </>
  );
};

export default PrivateLayoutNavbar;
